import React from "react"
import Icon from "src/shared/icons"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardFooter from "../../shared/RoomCardFooter/RoomCardFooter"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./Maintenance.css"
import { useNavigate } from "react-router-dom"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import { useFilterTipoMantenimiento } from "src/shared/providers/TiposMantenimientoProvider"
import { useDate } from "src/shared/hooks/useDate"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"

const Maintenance = ({
    roomTypeName,
    roomNumber,
    dateStatusChanged,
    hasIncidences,
    maintenanceColaboradorPhotoUrl,
    room,
    maintenanceDetails,
}: Omit<RoomStatusProps, "roomStatus">) => {
    const navigate = useNavigate()
    const { tipoMantenimiento } = useFilterTipoMantenimiento({ size: "xl", name: maintenanceDetails || "" })
    const { UTCStringToLocalDate } = useDate()
    const [elapsedTime] = useElapsedTime(UTCStringToLocalDate(dateStatusChanged))

    return (
        <Wrapper bgColor={"var(--supervision-card)"}>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                iconName="tools"
                iconBgColor="var(--mantenimiento)"
                roomNumber={roomNumber}
                roomTypeName={roomTypeName}
            />
            <RoomCardBody verticalAlign="start">
                <div className="room-card--xl-maintenance__icon--wrapper">
                    {maintenanceColaboradorPhotoUrl ? (
                        <img
                            src={maintenanceColaboradorPhotoUrl}
                            className="room-card--xl-occupied-cleaning__icon--photo"
                        />
                    ) : (
                        <Icon name="userFilled" color="var(--deep-dark-gray)" height="20px" />
                    )}
                </div>
                <span className="room-card--xl-maintenance__motivo">{tipoMantenimiento.clave}</span>
                <span className="room-card--xl-maintenance__timer">{elapsedTime}</span>
            </RoomCardBody>
            <RoomCardFooter
                text="Finalizar"
                bgColor={"var(--white-transparent)"}
                onSliderTriggered={() => {
                    navigate(`/u/detalle-habitacion/liberar-mantenimiento/${room?.habitacion_id}`)
                }}
            />
        </Wrapper>
    )
}

export default Maintenance
